<template>
  <div class="animated fadeIn" style="height: 100%; width: auto">
    <!-- <b-carousel class="mt-2" style="text-shadow: 0px 0px 2px #000" fade indicators>
      <b-carousel-slide v-for="(im, key) in slideImg" v-bind:key="key">
        <template v-slot:img>
          <img
            class="d-block img-fluid"
            caption="Welcome To SPESIAL KUAH"
            :src="`img/slide/${im}.jpg`"
            style="width:900px !important"
          />
        </template>
      </b-carousel-slide>
    </b-carousel> -->
    <b-row>
      <b-col lg="3">
        <!--  v-if="dashboard.pelunasanDash.count>0" -->
        <div class="card border-left-primary shadow h-100 py-2" @click="
          $router.push({
            name: 'loan.pelunasan',
            params: { type: 'current_month' },
          })
        ">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="
                    text-xs
                    font-weight-bold
                    text-primary text-uppercase
                    mb-1
                  ">
                  Disburesement
                </div>
                <div class="font-weight-bold text-uppercase mb-1" style="font-size: 0.7em">
                  Today
                </div>
                <div class="h4 mb-0 font-weight-bold text-gray-800">
                  {{
                      dashboard.pelunasanDash &&
                      dashboard.pelunasanDash.count | numFormat
                  }}
                </div>
                <div class="font-weight-bold text-uppercase mb-1" style="font-size: 0.7em">
                  This Month
                </div>
                <div class="h4 mb-0 font-weight-bold text-gray-800">
                  {{
                      dashboard.pelunasanDash &&
                      dashboard.pelunasanDash.count | numFormat
                  }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fa fa-money fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </b-col>

      <b-col lg="3" @click="$router.push({ name: 'loan.installmentduewithprepaid' })">
        <div class="card border-left-primary shadow h-100 py-2" v-b-tooltip.hover
          title="Angsuran Jatuh Tempo Yang Memiliki Prepaid Lebih Dari 1 Kali Angsuran">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="
                    text-xs
                    font-weight-bold
                    text-primary text-uppercase
                    mb-1
                  ">
                  Repayment
                </div>
                <div class="h4 mb-0 font-weight-bold text-gray-800">
                  {{
                      dashboard.prepaid && dashboard.prepaid.count | numFormat
                  }}
                  NOA
                  <!-- <br>({{$store.state.user.matauang}} {{dashboard.prepaid.ttlamt |numFormat('0,0')}}) -->
                </div>
                <br />
                <div class="font-weight-bold text-uppercase mb-1" style="font-size: 0.7em">
                  Periode Date Untill
                  {{ dashboard.prepaid && dashboard.prepaid.due_date }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fa fa-money fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="justify-content-center" style="margin-top: 50px">
      <b-col lg="6">
        <b-card no-body>
          <disbursement7days />
        </b-card>
      </b-col>
      <b-col lg="6">
        <b-card no-body>
          <repayment7days />
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-center" style="margin-top: 50px">
      <b-col>
        <b-card>
          <div slot="header">
            Todo List
            <div class="card-header-actions">
              <b-pagination align="right" style="margin-bottom: 0px !important" :total-rows="tblData.total"
                :per-page="tblData.limit" v-model="tblData.page"></b-pagination>
            </div>
          </div>

          <!-- <div class="mb-0 ml-3 mr-3">
                    <b-row>
                      <b-col lg="5">
                        <b-input-group>
                              <b-input-group-prepend>
                                <label style="width:30px;">Task Description</label>
                              </b-input-group-prepend>
                              <b-form-input v-model="tblData.taskdetail" placeholder="Task Description" style="width:100px;"></b-form-input>
                            </b-input-group>
                      </b-col>
                      <b-col lg="7">
                        <b-input-group>
                              <b-input-group-prepend>
                                <label style="width:30px;">Created At</label>
                              </b-input-group-prepend>
                                <b-form-input v-model="tblData.tgl1" type="date" style="max-width:70px;"></b-form-input>
                              <b-input-group-prepend>
                                <span class="input-group-text">until</span>
                              </b-input-group-prepend>
                              <b-form-input v-model="tblData.tgl2" type="date" style="max-width:70px;"></b-form-input>
                              <b-button variant="success" size="sm" @click="refresh()" class="ml-3">
                                <i class="fa fa-refresh"></i> Apply Filter
                              </b-button>
                              <b-button
                                variant="secondary"
                                size="sm"
                                class="ml-2"
                                @click="clearFilter()"
                              >Clear Filter</b-button>
                            </b-input-group>
                      </b-col>
                    </b-row>
                  </div> -->

          <div style="margin-top: 10px">
            <b-table class="mb-0" ref="table" outlined responsive striped hover small style="font-size: smaller"
              :items="data" :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit"
              :sort-by.sync="tblData.sortBy" :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" :busy="isBusy"
              @row-clicked="selectItem" show-empty>
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(empty)="data">
                <h4>{{ data.emptyText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
              <template v-slot:cell(createdate)="data">
                {{ data.item.createdate | moment("DD MMM YYYY") }}
              </template>
            </b-table>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="justify-content-center" style="margin-top: 50px">
      <b-col>
        <b-card border-variant="info" header="Info" header-bg-variant="info" header-text-variant="dark">
          <div slot="header">
            Todo List History
            <div class="card-header-actions">
              <b-pagination v-show="tblDataHistory.items.length > 0" align="right" style="margin-bottom: 0px !important"
                :total-rows="tblDataHistory.total" :per-page="tblDataHistory.limit"
                v-model="tblDataHistory.page"></b-pagination>
            </div>
          </div>

          <div class="mb-0 ml-3 mr-3">
            <b-row>
              <b-col lg="6">
                <b-row>
                  <b-col lg="12">
                    <b-input-group>
                      <b-input-group-prepend>
                        <label style="width: 60px">Task Description</label>
                      </b-input-group-prepend>
                      <b-form-input v-model="tblDataHistory.taskdetail" placeholder="Task Description"
                        style="width: 100px"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6">
                    <b-input-group>
                      <b-input-group-prepend>
                        <label style="width: 60px">Action Take</label>
                      </b-input-group-prepend>
                      <b-form-select v-model="tblDataHistory.actiontake" :plain="true" :options="optActionTake"
                        style="min-width: 70px !important"></b-form-select>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">
                    <b-input-group>
                      <b-input-group-prepend>
                        <label style="width: 60px">Final Approval</label>
                      </b-input-group-prepend>
                      <b-form-select v-model="tblDataHistory.finalapproval" :plain="true" :options="optFinalApproval"
                        style="min-width: 70px !important"></b-form-select>
                    </b-input-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="6">
                <b-row>
                  <b-col lg="12">
                    <b-input-group>
                      <b-input-group-prepend>
                        <label style="width: 60px">Action Date</label>
                      </b-input-group-prepend>
                      <b-form-input v-model="tblDataHistory.tglaction1" type="date"></b-form-input>
                      <b-input-group-prepend>
                        <span class="input-group-text">until</span>
                      </b-input-group-prepend>
                      <b-form-input v-model="tblDataHistory.tglaction2" type="date"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="12">
                    <!-- <b-input-group>
                              <b-input-group-prepend>
                                <label style="width:60px;">Created At</label>
                              </b-input-group-prepend>
                              <b-form-input v-model="tblDataHistory.tgl1" type="date"></b-form-input>
                              <b-input-group-prepend>
                                <span class="input-group-text">until</span>
                              </b-input-group-prepend>
                              <b-form-input v-model="tblDataHistory.tgl2" type="date"></b-form-input>
                            </b-input-group> -->
                    <div class="text-right mb-2 mt-1">
                      <b-button variant="success" size="sm" @click="refreshHistory()" class="ml-3">
                        <i class="fa fa-refresh"></i> Apply Filter
                      </b-button>
                      <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilterHistory()">Clear
                        Filter</b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>

          <div style="margin-top: 10px">
            <b-table class="mb-0" ref="tablehistory" outlined responsive striped hover small style="font-size: smaller"
              :items="datahistory" :fields="tblFieldsHistory" :current-page="tblDataHistory.page"
              :per-page="tblDataHistory.limit" :sort-by.sync="tblDataHistory.sortBy"
              :sort-desc.sync="tblDataHistory.sortDesc" :key="tblDataHistory.limit" :busy="isBusy"
              @row-clicked="selectItem" show-empty>
              <template v-slot:cell(empty)="data">
                <h4>{{ data.emptyText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
              <template v-slot:cell(createdate)="data">
                {{ data.item.createdate | moment("DD MMM YYYY") }}
              </template>
            </b-table>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="justify-content-center" style="margin-top: 50px" v-show="user.userrole == 'superadmin'">
      <b-col>
        <b-card border-variant="warning" header="warning" header-bg-variant="warning" header-text-variant="dark">
          <div slot="header">
            Log List
            <div class="card-header-actions">
              <b-pagination align="right" style="margin-bottom: 0px !important" :total-rows="tblDataHistory.total"
                :per-page="tblDataHistory.limit" v-model="tblDataHistory.page"></b-pagination>
            </div>
          </div>
          <div style="margin-top: 10px">
            <b-table class="mb-0" ref="table" outlined responsive striped hover small style="font-size: smaller"
              :items="datahistory" :fields="tblFieldsHistory" :current-page="tblDataHistory.page"
              :per-page="tblDataHistory.limit" :sort-by.sync="tblDataHistory.sortBy"
              :sort-desc.sync="tblDataHistory.sortDesc" :key="tblDataHistory.limit" :busy="isBusy"
              @row-clicked="selectItem" show-empty>
              <template v-slot:cell(createdate)="data">
                {{ data.item.createdate | moment("DD MMM YYYY") }}
              </template>
              <!-- <template v-slot:cell(actiondate)="data">
                    {{ data.item.actiondate | moment("DD MMM YYYY hh:mm") }}
                  </template> -->
            </b-table>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss" scoped>
.card {
  &.link {
    cursor: pointer;
    transition: all 0.4s;

    &:hover {
      background-color: #f0f3f5;
    }
  }

  // .card-body {
  //   height: 140px;
  // }
}

h5 {
  i {
    margin-right: 5px;
  }
}

ul {
  padding-left: 0;

  .sub-link {
    display: block;
    margin-left: 10px;

    i {
      width: 20px;
    }

    li {
      display: block;
      padding-left: 20px;

      i {
        width: 15px;
      }
    }
  }
}
</style>


<script>
import moment from "moment";
import toastr from "mini-toastr";
import modules from "../../apis/modules";
import disbursement7days from '../../views/charts/disbursement7days.vue';
import repayment7days from '../../views/charts/repayment7days.vue'
import disbursementRepaymentMonthly from '../../views/charts/disbursementRepaymentMonthly.vue'


toastr.init();

export default {
  components: {
    disbursement7days, repayment7days, disbursementRepaymentMonthly
  },
  data() {
    return {
      slideImg: [1, 2, 3, 4, 5, 6, 7, 8],
      isBusy: false,
      user: this.$store.state.user,
      model: {},
      tblData: {
        items: [],
        page: 1,
        limit: 10,
        total: 0,
        sortBy: "createdate",
        sortDesc: false,
        sortDir: "asc",
        taskdetail: "",
        tgl1: moment().add(-3, "month").format("YYYY-MM-DD"),
        tgl2: moment().format("YYYY-MM-DD"),
      },
      tblDataHistory: {
        items: [],
        page: 1,
        limit: 10,
        total: 0,
        sortBy: "createdate",
        sortDesc: false,
        sortDir: "desc",
        taskdetail: "",
        tgl1: "",
        tgl2: "",
        tglaction1: moment().add(-3, "month").format("YYYY-MM-DD"),
        tglaction2: moment().format("YYYY-MM-DD"),
        actiontake: "",
        finalapproval: "",
      },
      optActionTake: [
        { value: "", text: "-- ALL --" },
        { value: "Approved", text: "Approved" },
        { value: "Rejected", text: "Rejected" },
      ],
      optFinalApproval: [
        { value: "", text: "-- ALL --" },
        { value: "Approved", text: "Approved" },
        { value: "Rejected", text: "Rejected" },
      ],
    };
  },
  computed: {
    dashboard() {
      return this.$store.state.dashboard;
    },
    tblFields() {
      const fields = [
        {
          key: "taskname",
          thStyle: "width:200px",
          label: "Task Name",
          sortable: true,
        },
        {
          key: "taskdetail",
          label: "Task Description",
        },
        {
          key: "createby",
          label: "Created By",
          sortable: true,
        },
        {
          key: "createdate",
          thStyle: "width:110px",
          label: "Created At",
          sortable: true,
        },
      ];
      return fields;
    },
    tblFieldsHistory() {
      const fields = [
        {
          key: "taskname",
          thStyle: "width:200px",
          label: "Task Name",
          sortable: true,
        },
        {
          key: "taskdetail",
          label: "Task Description",
        },
        {
          key: "actiontake",
          label: "Action Take",
        },
        {
          key: "actiondate",
          label: "Action Date",
        },
        {
          key: "finalapproval",
          label: "Final Approval",
        },
        {
          key: "createby",
          label: "Created By",
          sortable: true,
        },
        {
          key: "createdate",
          thStyle: "width:110px",
          label: "Created At",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },

  async created() {
    // console.log('this.user',this.user)
  },

  methods: {
    data: async function (ctx) {
      try {
        this.isBusy = true;
        const { list, total } = await modules.listtodo(this.tblData);
        this.tblData.items = list;
        const this_ = this;
        setTimeout(() => {
          this_.tblData.total = total;
        }, 500);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    datahistory: async function (ctx) {
      try {
        const { list, totalhistory } = await modules.listtodoHistory(
          this.tblDataHistory
        );
        this.tblDataHistory.items = list;
        const this_ = this;
        setTimeout(() => {
          this_.tblDataHistory.total = totalhistory;
        }, 500);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    selectItem(item, index) {
      const dataParam = JSON.parse(item.routeParam);
      const routeParam = {
        key: dataParam.key,
        taskkey: dataParam.taskkey,
        taskname: item.taskname,
      };
      if (item.routeParam) {
        router.push({ name: item.routeName, params: routeParam });
      } else {
        router.push({ name: item.routeName });
      }
    },
    clearFilter() {
      this.tblData.taskdetail = "";
      this.tblData.tgl1 = moment().add(-3, "month").format("YYYY-MM-DD");
      this.tblData.tgl2 = moment().format("YYYY-MM-DD");
      this.refresh();
    },
    clearFilterHistory() {
      this.tblDataHistory.taskdetail = "";
      this.tblDataHistory.tglaction1 = moment()
        .add(-3, "month")
        .format("YYYY-MM-DD");
      this.tblDataHistory.tglaction2 = moment().format("YYYY-MM-DD");
      this.tblDataHistory.actiontake = "";
      this.tblDataHistory.finalapproval = "";
      this.refreshHistory();
    },
    async refresh() {
      try {
        this.tblData.page = 1;
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refreshHistory() {
      try {
        this.tblDataHistory.page = 1;
        this.$refs.tablehistory.refresh();
      } catch (error) {
        //this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
  },
};
</script>
